import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Modal,
  PartialWidthContainer,
  ToDoHeading,
  ToDoItem,
  ToDoScreenBase,
  Txt,
  Icon,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProperty } from 'state';
import {
  TodoItemEPC,
  TodoItemEICR,
  TodoItemGAS,
  TodoItemAlarms,
} from './bricks';
import styles from './PropertyViewTodoScreen.module.scss';

const items = {
  standards: {
    epcUrl: {
      key: 'epcUrl',
      title: 'Energy performance certificate (EPC)',
      component: TodoItemEPC,
      label: 'Energy performance certificate (EPC)',
      checked: false,
    },
    eicrUrl: {
      key: 'eicrUrl',
      title: 'Electrical installation condition report (EICR)',
      component: TodoItemEICR,
      label: 'Electrical installation condition report (EICR)',
      checked: false,
    },
    gscUrl: {
      key: 'gscUrl',
      title: 'Gas safety certificate',
      component: TodoItemGAS,
      label: 'Gas safety certificate',
      checked: false,
    },
    smokeAlarmsChecked: {
      key: 'smokeAlarmsChecked',
      title: 'Smoke and carbon monoxide alarms',
      component: TodoItemAlarms,
      label: 'Smoke and carbon monoxide alarms',
      checked: false,
    },
  },
  management: {
    tenants: {
      label: 'Get tenants',
      checked: false,
    },
    inventory: {
      label: 'Add to inventory',
      checked: false,
    },
  },
  custom: {},
};

/**
 * PropertyViewTodoScreen
 *
 * @return {JSX.Element}
 */
const PropertyViewTodoScreen = ({ className }) => {
  const [activeTodo, setActiveTodo] = useState(null);
  const navigate = useNavigate();
  const propertyDoc = useProperty();

  const handleBack = () => navigate('../main/manage');
  const handleOpen = (todoItem) => () => setActiveTodo(todoItem);

  const handleGoTo = (itemKey) => () => {
    console.log('Go to', itemKey);
    navigate(`../main/manage?highlight=${itemKey}`);
  };

  const handleClose = () => setActiveTodo(null);

  return (
    <PartialWidthContainer
      className={classNames(
        styles.PropertyViewTodoScreen,
        className,
        PropertyViewTodoScreen.displayName
      )}
      column
      small
      gap
    >
      <FlexContainer>
        <Button onClick={handleBack}>
          <Icon s name="goback" /> Back to property
        </Button>
      </FlexContainer>
      <ToDoHeading
        description1="Tap on the task to view a guide and information on how to complete."
        description2="All of the property standards tasks must be complete for a tenancy to start or at least renewed during a tenancy."
      />
      <FlexContainer column gap>
        <Txt xx>Property standards</Txt>
        {Object.keys(items.standards).map((key) => {
          const todoItem = items.standards[key];

          return (
            <ToDoItem
              key={todoItem.key}
              red
              label={todoItem.label}
              checked={!!propertyDoc.data.standards[todoItem.key]}
              // onClick={handleChange('standards', key)}
              onClick={handleOpen(todoItem)}
            />
          );
        })}
      </FlexContainer>
      <FlexContainer column gap>
        <Txt xx>Management</Txt>
        {Object.keys(items.management).map((key) => {
          const item = items.management[key];

          return (
            <ToDoItem
              key={key}
              green
              label={item.label}
              onClick={handleGoTo(key)}
              goto
            />
          );
        })}
      </FlexContainer>
      {activeTodo ? (
        <Modal onClose={handleClose} title={activeTodo.title} showCloseButton>
          <ToDoScreenBase>
            <activeTodo.component onSuccess={handleClose} />
          </ToDoScreenBase>
        </Modal>
      ) : null}
    </PartialWidthContainer>
  );
};

PropertyViewTodoScreen.displayName = 'PropertyViewTodoScreen';

export default observer(PropertyViewTodoScreen);
